export default __webpack_public_path__ + "images/3856c8f714de539ec2309b7b378f2cf0.png";